import * as React from "react";
import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";
import { ApiBaseUrl } from "../../config";
import { fetchData } from "../../common/services/ApiClient";

export default function MaintenanceDashboard() {
  const [bannerData, setBannerData] = React.useState({
    is_active: "",
    description: "",
    ID: "",
    title: "",
  });
  const [title, setTitle] = React.useState(bannerData.title);
  const [description, setDescription] = React.useState(bannerData.description);
  const [status, setStatus] = React.useState(bannerData.is_active);

  const token: string =
    Object.fromEntries(new URLSearchParams(window.location.search).entries())
      .token || "";
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };
  const handleDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDescription(event.target.value);
  };
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value);
  };
  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      (async () => {
        await fetch(`${ApiBaseUrl()}/maintenance/isAdmin?token=${token}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then(response => {
            //add redirct if not true
            if (!response.authorized) {
              window.location.replace("/");
            }
          })
          .catch((error: Error) => {
            console.error(error);
          });
      })();
      return () => {
        isMounted = false;
      };
    }
  }, [token]);

  React.useEffect(() => {
    let isMounted = true;

    (async () => {
      await fetchData(`${ApiBaseUrl()}/maintenance`)
        .then((response: any) => {
          if (isMounted && response.data) {
            response.data[0] && setBannerData(response.data[0]);
            response.data[0] && setTitle(response.data[0].title);
            response.data[0] && setStatus(response.data[0].is_active);
            response.data[0] && setDescription(response.data[0].description);
          }
        })
        .catch((error: Error) => {
          console.error(`${error.name} : ${error.message}`);
        });
    })();
    return () => {
      isMounted = false;
    };
  }, []);
  const headerText = (
    <Grid item xs={12}>
      <Typography variant="h1" id="dashboard">
        Maintenance Dashboard
      </Typography>
    </Grid>
  );
  const handleSubmit = async () => {
    await fetch(
      `${ApiBaseUrl()}/maintenance?token=${token}&is_active=${status}&description=${description}&title=${title}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "appliction/json",
          "x-rate-limit": "off",
        },
        body: JSON.stringify({
          data: {
            is_active: status,
            description: description,
            ID: "maintenance",
            title: title,
          },
        }),
      },
    )
      .catch(error => {
        console.error(error);
        return error;
      })
      .finally(() => {
        window.location.reload();
      });
  };
  const handleCancel = () => {
    setTitle(bannerData.title);
    setStatus(bannerData.is_active);
    setDescription(bannerData.description);
  };
  return (
    <>
      <CloudFoundryBanner />
      <Grid item sm={12} xs={12} style={{ position: "relative" }}>
        {headerText}
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        alignItems="right"
        spacing={2}
      >
        <Grid item>
          <InputLabel>IS Active</InputLabel>
          <Select value={status} onChange={handleStatusChange}>
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </Grid>
        <Grid item>
          <InputLabel>Title</InputLabel>
          <TextField
            id="maintenance_title"
            style={{ minWidth: 1000 }}
            value={title}
            onChange={handleTitleChange}
          ></TextField>
        </Grid>
        <Grid item>
          <InputLabel>Description</InputLabel>
          <TextField
            id="maintenance_description"
            style={{ minWidth: 1000 }}
            value={description}
            onChange={handleDescriptionChange}
          />
        </Grid>
      </Grid>
      <Grid spacing={2} container style={{ paddingTop: 16 }}>
        <Grid item>
          <Button onClick={handleSubmit} variant="contained">
            Save
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleCancel} variant="contained">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
